import React, { createContext, useContext } from 'react'
import { Room } from 'twilio-video'

import { CS } from '../components/calls/call_manager/connection_status_reducer'
import { NavToChatViewType } from '../components/calls/call_manager/use_call_nav_handler'

export type RoomDataType = {
  initialAudioDeviceId?: string
  initialVideoDeviceId?: string
  lastClosedRoomSid?: string
}

export type ActiveCallType = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  callRecord?: any
  initialAudioDeviceId?: string
  initialVideoDeviceId?: string
  room?: Room
  lastClosedRoomSid?: string
  navToVideoView?: () => void
  navToChatView?: NavToChatViewType
  setMemberCacheToChatView?: () => void
  isOnCall?: boolean
  callErrors?: string[]
  connectionStatus?: CS
  prevConnectionStatus?: CS
}

export const initialCallManagerValue = {
  activeCall: {},
  joinCall: undefined,
  joinCallForNewDirectChat: undefined,
  isJoining: undefined,
  leaveCall: undefined,
  openCalls: {},
}

export type LeaveCallType = (
  event?: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  options?: {
    playLeaveSound: boolean
  },
) => Promise<any>

export type OpenCallsType =
  | { [memberId: number]: { topicId: number; directChatHandle: string }[] }
  | Record<number, never>

export type UseCallManagerType = {
  activeCall: ActiveCallType
  joinCall?: ({
    topicId,
    upgradingToRoom,
    callType,
  }?: {
    topicId?: number
    upgradingToRoom?: boolean
    callType: 'audio' | 'video'
  }) => Promise<any>
  joinCallForNewDirectChat?: (
    directChatHandle: string,
    options: { callType: 'audio' | 'video' },
  ) => Promise<any>
  isJoining?: boolean
  leaveCall?: LeaveCallType
  openCalls: OpenCallsType
}

export const CallManagerContext = createContext<UseCallManagerType>(
  initialCallManagerValue,
)

export const useCallManager = () => useContext(CallManagerContext)
